import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { DatastoreService } from '../../services/datastore.service';
import { ApiService } from '../../services/jrni/api.service';

@Component({
  selector: 'app-estore-fail',
  templateUrl: './estore-fail.component.html',
  styleUrls: ['./estore-fail.component.scss']
})
export class EstoreFailComponent implements OnInit {


  estoreError = "Your payment has not been successful"

  constructor(
    private spinner: NgxSpinnerService,
    private dataStore: DatastoreService,
    private router: Router,
    private apiService: ApiService
  ) { }

  ngOnInit() {
    this.spinner.hide();
    const err = JSON.parse(localStorage.getItem('estoreError'));
    if (err) {
      this.estoreError = err;
    }
  }

  retry() {
    const url = JSON.parse(localStorage.getItem('estoreUrl'));
    if (!url) {
      console.error('No stored gateway URL to retry; restarting instead');
      this.restartJourney();
      return;
    }
    window.location = url;
  }

  async restartJourney() {
    this.spinner.show();

    localStorage.removeItem('purchase');
    localStorage.removeItem('selectedService');
    localStorage.removeItem('selectedSlot');
    localStorage.removeItem('scp');
    localStorage.removeItem('bookingDetails');
    localStorage.removeItem('estoreUrl');

    // On the Civica pre-basket (book-after-payment) flow there is no booking to
    // cancel — payment failed before one was ever created, so `booking` is
    // absent. Only the older book-first flow leaves one behind.
    let bookings = null;
    try {
      bookings = JSON.parse(localStorage.getItem('booking'));
    }
    catch (err) {
      console.error('Could not read stored booking:', err);
    }

    if (bookings) {
      try {
        if (bookings.id === undefined) {
          for (const i in bookings) {
            const booking = bookings[i];
            await this.apiService.cancelMultiBookings(
              booking.company_id,
              booking.id,
            );
          }
        } else { // block bookings
          const booking = bookings;
          await this.apiService.cancelMultiBookings(
            booking.company_id,
            booking.id,
          );
        }
      }
      catch (err) {
        console.error('Could not cancel the abandoned booking:', err);
      }
    }
    localStorage.removeItem('booking');
    this.spinner.hide();

    this.router.navigate(['/start']);
  }

  // puts back below next when on a mobile device
  mobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
  }

}
